import { AssignmentRelationType } from "@kolibrisoftware/customerportal-api";
import { MENU_ITEMS, MenuItem, MenuItemsUseCase } from "constants/menu-items";
import { ROUTER_PATHS } from "constants/routes";
import { useSelector } from "store/helpers";

/**
 * Returns a list of menu items filtered on
 *  - useCase
 *  - userDefinedFilters
 */
export default function useMenuItems(useCase: MenuItemsUseCase): MenuItem[] {
  const companyData = useSelector(state => state.main.companyData);
  const { assignmentDetails, userLinkType } = useSelector(
    state => state.dossier
  );

  return MENU_ITEMS.filter(item => item.useCase?.includes(useCase)).filter(
    item => {
      switch (item.path) {
        case ROUTER_PATHS.REALTOR:
          return !!companyData;
        case ROUTER_PATHS.OBJECT_PREVIEW:
          return assignmentDetails?.showPreview;
        case ROUTER_PATHS.LANGUAGE_SWITCH:
          return !!Object.entries(assignmentDetails)?.length;
        case ROUTER_PATHS.EERLIJK_BIEDEN:
          const hasCorrectRole =
            userLinkType === AssignmentRelationType.Potential ||
            userLinkType === AssignmentRelationType.PurchasingBroker;
          return (
            assignmentDetails.safeBiddingPlatformUrl?.length && hasCorrectRole
          );
        default:
          return true;
      }
    }
  );
}
